import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import apiRequest from "../../functions/api";
import {
  Box,
  TextField,
  Typography,
  Button,
  Grid,
  Hidden,
  Alert,
  AlertTitle,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useMessage } from "../../context/message-context";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth-context";
function ChangePassword() {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState(null);
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const { user } = useAuth();
  const navigate = useNavigate();
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowCurrentPassword = () => {
    setShowCurrentPassword(!showCurrentPassword);
  };

  const newPasswordCb = (response) => {
    if (response.status === 200) {
      showSuccessMessage(t("Freischaltung erfolgreich."));
      navigate(-1);
    } else {
      showErrorMessage(response.data.message);
    }
  };
  function validatePassword() {
    var errors = [];
    if (newPassword.length < 8) {
      errors.push("Ihr Passwort muss mindestens 8 Zeichen enthalten");
    } else if (newPassword.search(/[a-z]/) < 0) {
      errors.push(
        "Ihr Passwort muss mindestens einen Kleinbuchstaben enthalten"
      );
    } else if (newPassword.search(/[A-Z]/) < 0) {
      errors.push(
        "Ihr Passwort muss mindestens einen Großbuchstaben enthalten"
      );
    } else if (newPassword.search(/[0-9]/) < 0) {
      errors.push("Ihr Passwort muss mindestens eine Ziffer enthalten");
    } else if (
      newPassword.search(/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/) < 0
    ) {
      errors.push("Ihr Passwort muss mindestens ein Sonderzeichen enthalten");
    }
    if (errors.length > 0) {
      setNewPasswordError(errors.join("\n"));
      return false;
    } else {
      setNewPasswordError(null);
    }
    return true;
  }

  const handlePasswordChangeClick = (e) => {
    e.preventDefault();
    if (!validatePassword()) return;
    if (newPassword !== confirmPassword) {
      setConfirmPasswordError("Ihre Eingaben stimmen nicht überein.");
      return;
    }
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      password: currentPassword,
      newpw: newPassword,
    };
    apiRequest("POST", "changepassword", payload, headers, newPasswordCb);
  };
  return (
    <Page>
      <Layout>
        <Box p={2}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">{t("Passwort ändern")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                {t("Bitte vergeben Sie ein neues Passwort für Ihren Account.")}
              </Typography>
            </Grid>
          </Grid>
          <form>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Hidden mdDown>
                <Grid item xs={4} alignContent="center" align="left">
                  <Typography variant="body1">
                    {t("Aktuelles Passwort")}
                  </Typography>
                </Grid>
              </Hidden>
              <Grid item xs={12} md={8} align="left">
                <TextField
                  type={showCurrentPassword ? "text" : "password"}
                  fullWidth
                  label={t("Aktuelles Passwort")}
                  variant="outlined"
                  id="newpassword"
                  placeholder="Passwort eingeben ..."
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowCurrentPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showCurrentPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Hidden mdDown>
                <Grid item xs={4} alignContent="center" align="left">
                  <Typography variant="body1">{t("Neues Passwort")}</Typography>
                </Grid>
              </Hidden>
              <Grid item xs={12} md={8} align="left">
                <TextField
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  error={newPasswordError}
                  helperText={newPasswordError}
                  label={t("Neues Passwort")}
                  variant="outlined"
                  id="newpassword"
                  placeholder="Passwort eingeben ..."
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Hidden mdDown>
                <Grid item xs={4} alignContent="center" align="left">
                  <Typography variant="body1">
                    {t("Passwort wiederholen")}
                  </Typography>
                </Grid>
              </Hidden>
              <Grid item xs={12} md={8} align="left">
                <TextField
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  error={confirmPasswordError}
                  helperText={confirmPasswordError}
                  label={t("Neues Passwort bestätigen")}
                  variant="outlined"
                  id="confirmpassword"
                  placeholder="Passwort eingeben ..."
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                {user.zugriff === "3" && (
                  <Alert severity="warning">
                    <AlertTitle align="left">{t("Hinweis")}</AlertTitle>
                    {t(
                      "Bitte beachten Sie, dass sich durch Ihre Änderung auch das Passwort von Ihrem SCHECK Zugang ändert."
                    )}
                  </Alert>
                )}
              </Grid>
              <Grid item xs={12} sm={10} md={8}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handlePasswordChangeClick}
                >
                  {t("Passwort ändern")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Layout>
    </Page>
  );
}
export default ChangePassword;
